import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_STATUSPENDS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_STATUSPEND, res.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveItem(obj).then(res => {
    commit(types.SET_STATUSPEND, res.data)
    return res
  })
}

export const deleteStatusPend = async ({ commit }, obj) => {
  await services.deleteStatusPend(obj).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}
